export default "__VITE_ASSET__7ab2bd03__"